import { memo } from "react";

import { FLAVOR_CONFIG } from "@/lib/flavor-config";
import { cn } from "@/lib/utils";

interface ICopyrightNoticeProps {
  testId: string;
  className?: string;
}

// NOTE: NSAI-7288 — the copyright line since the footer bar went away. The
// bar took a 2rem strip under every page and pushed the chat composer up; the
// line is now overlaid on the bottom-right corner of the app shell, and the
// account menu carries it wherever that corner is not shown. Plain text, not a
// control: it does nothing on click and stays out of the menu's keyboard
// navigation.
export const CopyrightNotice = memo(
  ({ testId, className }: ICopyrightNoticeProps): React.JSX.Element => (
    <p data-testid={testId} className={cn("text-xs", className)}>
      {/* NOTE: NSAI-6321 — deliberately NOT the organization's platform name.
          This line names the copyright holder, which is the vendor and stays
          the vendor whatever an organization calls the product; an
          organization's own name here would assert it owns the software. The
          rename covers the product name only. */}
      {new Date().getFullYear()} © {FLAVOR_CONFIG.companyName}
    </p>
  ),
);

CopyrightNotice.displayName = "CopyrightNotice";
